import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, inject, Input, Output, ViewChild } from '@angular/core';
import { UserService, userServiceToken } from 'go-modules/models/user/user.service';
import { CourseFolder } from '@go-modules/services/course/interfaces/course-folder.interface';
import { MenuComponent } from '@go-modules/components/menus/menu/menu.component';
import { NgxFeatureFlagService } from '@go-modules/services/feature-flag/feature-flag.service';
import { BadgeColors } from '@go-modules/components/badge/badge.constants';
import { FIRST_COMMENT_TOUR_CLASSES } from '@go-modules/services/go-pulse-tour/constants/first-comment-tour';
import { ResponsiveLayoutService } from '@go-modules/services/responsive-layout/responsive-layout.service';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';

@Component({
	selector: 'folder-card',
	templateUrl: './folder-card.component.html',
	styleUrls: ['./folder-card.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
	host: {
		'[class]': 'responsiveLayout.cssClassString()'
	}
})
export class FolderCardComponent {
	protected responsiveLayout = inject(ResponsiveLayoutService);
	@Input() public folder: any;
	@Output() public goToFolder: EventEmitter<any>  = new EventEmitter();
	@ViewChild(MenuComponent) public menuComponent: MenuComponent;
	@ViewChild('cardContainer', {read: ElementRef}) public cardContainer: ElementRef;
	public selectedFolder: any;
	public BadgeColors = BadgeColors;
	public FirstCommentTourClasses = FIRST_COMMENT_TOUR_CLASSES;
	public folderNameTruncated = null;

	constructor (
		private featureFlag: NgxFeatureFlagService,
		private cdr: ChangeDetectorRef,
		private translate: TranslateService,
		@Inject(userServiceToken) private userService: UserService
	) {}

	public openMenu (event: MouseEvent) {
		event.stopPropagation();
		// open browser menu on shift right click
		if (event.button === 2 && event.shiftKey) {
			return;
		}
		if (!this.canOpenMenu()) {
			return;
		}

		event.preventDefault();
		this.selectedFolder = this.folder;
		this.menuComponent.openMenu(event, this.cardContainer.nativeElement);
	}

	public canOpenMenu (): boolean {
		return this.folder.hasInstructorRole(true) || this.userService.currentUser.is_root_user;
	}

	public unviewedState (folder: CourseFolder): boolean {
		return folder.hasReviewerRole(true) && folder.stats?.attention_needed;
	}

	public shouldShowFreeTrialBadge (): boolean {
		if (this.featureFlag.isAvailable('AI_TRIAL')) {
			return this.folder.hasInstructorRole(true) && this.folder.stats?.license_trial_exists;
		}
		return false;
	}

	public handleTruncatedChange (folderNameTruncated: boolean) {
		this.folderNameTruncated = folderNameTruncated;
		this.cdr.detectChanges();
	}

	public getAriaLabel (folder: CourseFolder) {
		return folder.name + ', ' + this.translate.instant('course-table-last_modified') + ' ' + dayjs(folder.updated_at).format('MMM D, YYYY');
	}
}
